@defer {
  <div tabindex="0" class="back" (keydown)="back()" (click)="back()">
    <svg-icon src="{{ assetsDir }}assets/icons/arrow-back-icon.svg"></svg-icon>
    {{ 'global.back' | transloco }}
  </div>
  <div class="panel w-100">
    <div class="panel-main">
      <app-navigation class="with-divider" [shop]="shop" [shopUrl]="nameShop"></app-navigation>
      <ng-container *ngIf="!showAppicNewAccount && !showAppicUpdateForm && !showNullUpdateForm">
        <div class="row mt-4 login-container">
          <a
            class="btn btn-facebook wide-btn"
            (click)="setFacebookRedirect(true)"
            href="facebook-login-redirect/shop/{{ shopService.shop.url_extension }}/shopping-cart/{{
              shopService.shoppingCart ? shopService.shoppingCart.uuid : ''
            }}?{{ shopService.source ? '&source=' + shopService.source : '' }}{{
              shopService.campaign ? '&campaign=' + shopService.campaign : ''
            }}"
          >
            <svg-icon src="{{ assetsDir }}assets/icons/icon-fb-3.svg" />
            <span class="ion ion-logo-facebook"></span>
            {{ 'details.login_appic.continue_with_facebook' | transloco }}
            <mat-spinner *ngIf="shopService.facebookRedirect" class="fb-spinner" [diameter]="32"></mat-spinner>
          </a>

          <!-- <a
              class="btn btn-facebook wide-btn"
              (click)="setFacebookRedirect(true)"
              *ngIf="orderUuid"
              href="facebook-login-redirect/shop/{{ shopService.shop.url_extension }}/order/{{ orderUuid }}?{{
                shopService.source ? '&source=' + shopService.source : ''
              }}{{ shopService.campaign ? '&campaign=' + shopService.campaign : '' }}"
            >
              <span class="ion ion-logo-facebook"></span>
              <svg-icon src="{{ assetsDir }}assets/icons/icon-fb-3.svg" />
              {{ 'details.login_appic.continue_with_facebook' | transloco }}
            </a> -->
          <button class="btn btn-primary wide-btn continue-with-appic-btn" (click)="openLoginDialog()">
            <span>{{ 'details.login_appic.continue_with' | transloco }}</span>
            <svg-icon src="{{ assetsDir }}assets/icons/appic-icon.svg" />
          </button>
        </div>
      </ng-container>
      <div class="billing-info">
        <h1 class="billing-header">{{ 'details.billing_information' | transloco }}</h1>
        <!-- to consider: putting details-form into defer, layout shift should be fixed then, ssr faster by 400ms -->
        <app-details-form (formInitEmitter)="detailsForm = $event"></app-details-form>
      </div>
    </div>
  </div>
}
